import type { FunctionComponent, ReactNode } from "react";
import { forwardRef } from "react";

import type { BaseLinkProps } from "./base-link";
import { BaseLink } from "./base-link";
import type { ButtonProps } from "./button";
import { Button } from "./button";

export interface LinkButtonProps
  extends
    Omit<ButtonProps, "href">,
    Omit<
      BaseLinkProps,
      "children" | "onClick" | "onMouseEnter" | "onTouchStart"
    > {
  children: ReactNode;
  linkProps?: Omit<BaseLinkProps, "children" | "href">;
}

export const LinkButton: FunctionComponent<LinkButtonProps> = forwardRef(
  ({ href, linkProps, ...rest }, ref) => {
    return (
      <BaseLink {...linkProps} href={href}>
        <Button ref={ref} {...rest} />
      </BaseLink>
    );
  },
);
